export default "assets/images/cnil-rgpd-check-7a75d272.png";